import axiosInstance from "../helpers/axiosInstance"
import S3Client from '../helpers/s3Client'

export const PACKING_PROOF_CONFIG = {
  newMultipartUploadPath: '/packing-proof/new-multipart-upload',
  generateMultipartUploadPresignedUrlsPath: '/packing-proof/upload-presigned-urls',
  completeMultipartUploadPath: '/packing-proof/complete-upload',
  listFilesWithPrefixPath: '/packing-proof/list',
}

export const listFilesWithPrefix = async (prefix) => {
  const s3Client = new S3Client(PACKING_PROOF_CONFIG)
  const objects = await s3Client.listFilesWithPrefix(prefix)
  return objects
}

export const downloadPackingProofVideo = async (path, filename) => {
  // Fetch the file as a blob and trigger download
  const response = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}${path}`, { responseType: 'blob' } )
  const blob = response.data
  const blobUrl = window.URL.createObjectURL(blob)

  const link = document.createElement("a")
  link.href = blobUrl
  link.setAttribute("download", filename || path.split("/").pop())
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(blobUrl)
  
  return true
}